require('./ctxTooltip.style.scss');
class ctxTooltipController {
    constructor($scope, $element, $attrs, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.down = false;
        this.show = false;
        this.calcTooltipHeight();

        this.$scope.$watch(() => this.showTooltip, (value, oldValue) => {
            let doc = document.documentElement,
                left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
                top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
                parentElement, haveSpaceForUp, haveSpaceForDown;
            if (typeof value === 'undefined' || value === oldValue) return;
            if (value) {
                haveSpaceForUp = this.minOverflowBorder <= (this.$element.offset().top - this.tooltipHeight + 45) || this.tooltipHeight > 100;
                haveSpaceForDown = this.maxOverflowBorder >= (this.$element.offset().top + this.tooltipHeight + 15);
                this.down = !this.showUp ? (haveSpaceForDown ? haveSpaceForDown : !haveSpaceForUp) : false;
                parentElement = this.$element.parent()[0];
                if (parentElement) {
                    let clientRect = parentElement.getBoundingClientRect();
                    this.parentWidth = clientRect.width;
                }
            }
            this.show = value;
            if (angular.isDefined(this.parentWidth)) {
                this.setWidth(value, this.parentWidth, top, left);
            }
        });
    }

    setWidth(show, parentWidth, top, left) {
        let tooltipContainer = this.$element.find('.ctx-tooltip-container'),
            ctxWidth = parseInt(tooltipContainer.css('width').split('px')[0]);
        tooltipContainer.css('margin-left', ((parentWidth - ctxWidth) / 2) - left);
        if (show) {
            this.marginBottom = this.getStyle(tooltipContainer[0], 'margin-bottom');
            tooltipContainer.css('margin-bottom', this.marginBottom + top);
        }
        else if (this.marginBottom) {
            this.marginBottom = this.getStyle(tooltipContainer[0], 'margin-bottom');
            tooltipContainer.css('margin-bottom', this.marginBottom - top);
            this.marginBottom = this.getStyle(tooltipContainer[0], 'margin-bottom');
        }
    }

    calcTooltipHeight() {
        this.hide = true;
        this.show = true;
        this.$timeout(() => {
            this.tooltipHeight = this.$element.find('.ctx-tooltip-container').outerHeight() + 5;
            this.show = false;
            this.hide = false;
        }, 0, false);
    }

    getStyle(e, styleName) {
        let styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        }
        else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return parseFloat(styleValue);
    }

}

ctxTooltipController.$inject = ['$scope', '$element', '$attrs', '$timeout'];

const ctxTooltipComponent = {
    controller: ctxTooltipController,
    transclude: true,
    template: require('./ctxTooltip.template.html'),
    scope: {},
    bindings: {
        showTooltip: '<',
        minOverflowBorder: '<',
        maxOverflowBorder: '<',
        showUp: '<?'
    }
};

module.exports = ctxTooltipComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTooltip/ctxTooltip.component.js